<template>
  <div class="flex min-w-0 flex-col gap-1">
    <span v-if="showLabel" class="text-xs text-muted-foreground">
      Title
    </span>
    <RouterLink
      v-if="taskTemplateRoute"
      :to="taskTemplateRoute"
      class="truncate font-medium text-foreground transition-colors hover:text-primary"
    >
      {{ title }}
    </RouterLink>
    <span v-else class="truncate font-medium text-foreground">
      {{ title }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

const props = defineProps({
  taskTemplate: {
    type: Object,
    default: null,
  },
  value: {
    type: [String, Object],
    default: null,
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
})

const title = computed(() => {
  if (typeof props.value === 'string' && props.value.trim() !== '') {
    return props.value
  }

  return 'Untitled task template'
})

const taskTemplateRoute = computed(() => {
  const taskTemplateId = Number(props.taskTemplate?.id)

  if (!Number.isInteger(taskTemplateId) || taskTemplateId <= 0) {
    return null
  }

  return {
    name: 'TaskTemplateShowPage',
    params: {
      taskTemplate: taskTemplateId,
    },
  }
})
</script>
